module.exports = __webpack_public_path__ + "assets/img/kv-8f4d946f.jpg";